import React from 'react';
import PropTypes from 'prop-types';
import request from '../../utils/agent';
import Loader from 'components/Loader';
import { Formik, Field, FieldArray, Form } from 'formik';
import * as Yup from 'yup';


const propTypes = {
    id: PropTypes.string,
};

export default class ViewAdminProfile extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            cData: { },
            user: { },
            loaded: false,
            editingProfile: false,
            isError: false,
            updateFlag: false,
        };
    }

    componentDidMount() {
        this.getAdminData(this.props.id);
        this.getcData(this.props.id);
    }


    componentDidUpdate() {
        if(this.state.updateFlag === true) {
            this.getAdminData(this.props.id);
            this.getcData(this.props.id);
            this.setState({
                updateFlag: false,
                editingProfile: false,
            });
        };
    }


    getAdminData (id) {
        return new Promise((resolve, reject) => {
            request.get(`/api/user/${id}`)
                .then(resp => {
                    this.setState({
                        user: resp.body.user,
                        loaded: true
                    });
                    resolve(resp.body);
                });

        });
    };

    getcData(id) {
        return new Promise((resolve, reject) => {
            request.get(`/api/user/${id}`)
                .then(resp => {
                    this.setState({cData: resp.body.user.cdata});
                    resolve(resp.body);
                });
        });
    };


    modalChangePasswordToggle = () => {
        let passwordModal = document.querySelector('#passwordModal');
        passwordModal.classList.toggle('show');
        passwordModal.nextSibling.classList.toggle('show');
    };

    editProfile = () => {
        this.setState({editingProfile: !this.state.editingProfile});
    };

    render() {
        //console.log('admin', this.state.user);
        if (this.state.loaded === true) {
            //console.log('role', this.state.user.role.name);
        }
       // console.log('loaded', this.state.loaded);
       // console.log('cdata', this.state.cData);
       // console.log('id', this.props.id);

        const roleOptions = [
            {id: "admin", display: "Admin", description: "Can edit and approve resellers"},
            {id: "architect", display: " Architect/Designer", description: "Architect or Designer"},
            {id: "developer", display: "Developer", description:"Developer"},
            {id: "distributor", display: "Distributor", description: "Can manage resellers"},
            {id: "installer", display: "Employee", description: "Basic NOON Pro access"},
            {id: "owner", display: "Owner", description: "Can create admin users"},
            {id: "user", display: "Reseller", description: "Can manage installers"},
        ];

       // console.log('roleOptions', roleOptions);



        const adminSchema = Yup.object().shape({
            email: Yup.string()
                .email('This value should be a valid email.')
                .required('This value is required.'),
            first_name: Yup.string()
                .required('This value is required.'),
            last_name: Yup.string()
                .required('This value is required.')
        });



        return (
            <section >
                {this.state.loaded === true ?
                    <div className='admin-profile-container'>
                        <div className='short-desc-hold'>
                            <h5>{this.state.cData.first_name} {this.state.cData.last_name}</h5>
                            <button className='edit-p-button' onClick={this.editProfile}>Edit Profile</button>
                        </div>
                        <div className='details-hold'>
                            {this.state.editingProfile === true ?
                                <Formik
                                    initialValues={{
                                        role: this.state.user.role.name,
                                        email: this.state.user.email,
                                        first_name: this.state.cData.first_name,
                                        last_name: this.state.cData.last_name,
                                    }}
                                    validationSchema={adminSchema}
                                    enableReinitialize={true}
                                    onSubmit={(values, actions) => {
                                        return new Promise((resolve, reject)=> {
                                            request.post(`/api/updateuser/${this.props.id}`)
                                                .send({
                                                    role: values.role,
                                                    email: values.email,
                                                    first_name: values.first_name,
                                                    last_name: values.last_name
                                                })
                                                .then(data => {
                                                    actions.setSubmitting(false);
                                                    //console.log('finished call');
                                                    //console.log(data);
                                                })
                                                .then(resp => {
                                                    this.setState({updateFlag: true})
                                                })
                                                .catch(err => {
                                                    console.error(err);
                                                    this.setState({isError: true});
                                                });
                                        });
                                    }}>

                                    {({
                                          values,
                                          errors,
                                          touched,
                                          handleChange,
                                          handleBlur,
                                          handleSubmit,
                                          isSubmitting,
                                          handleReset,
                                          resetForm,
                                          dirty,
                                          setFieldValue
                                      }) => (
                                        <Form className='my-f-form' onSubmit={handleSubmit}>
                                            <h3>Authorized Reseller Portal Permissions</h3>
                                            <FieldArray
                                                name='role'
                                                render={arrayHelpers => (
                                                    <div className='toggle-radio-gr-table'>
                                                        {roleOptions.map(option => (
                                                            <div key={option.id} className='toggle-radio-gr-container'>
                                                                <input
                                                                    name='role'
                                                                    type='checkbox'
                                                                    className='toggle--radio--btn'
                                                                    value={option.id}
                                                                    checked={values.role.includes(option.id)}
                                                                    onChange={() => {
                                                                        setFieldValue('role', option.id)
                                                                    }}
                                                                />
                                                                <div className='toggle--radio-content'>
                                                                    <div className='toggle--radio--title'>{option.display}</div>
                                                                    <div className='toggle--radio--subtitle'> {option.description} </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            />
                                            <h3>Primary Contact Information</h3>
                                            <label className='form-f-label'>Email*</label>
                                            <Field
                                                name='email'
                                                className={errors.email && touched.email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Email*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.email} />
                                            {errors.email && touched.email ?
                                                (<div className='f-field-errors'>{errors.email} </div>) : null
                                            }

                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='form-f-label'>First Name*</label>
                                                    <div className='flex-with-error-holder'>
                                                        <Field
                                                            name='first_name'
                                                            component='input'
                                                            className=   {errors.first_name && touched.first_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                            type='text'
                                                            placeholder='First Name*'
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.first_name}
                                                        />
                                                        {errors.first_name && touched.first_name ? (
                                                            <div className='f-field-errors'>{errors.first_name}</div>) : null
                                                        }
                                                    </div>
                                                </div>

                                                <div className='flex-field-container last'>
                                                    <label className='form-f-label'>Last Name*</label>
                                                    <div className='flex-with-error-holder'>
                                                        <Field
                                                            name='last_name'
                                                            component='input'
                                                            className= {errors.last_name && touched.last_name ?'form-f-field flex-with-error': 'form-f-field'}
                                                            type='text'
                                                            placeholder='Last Name*'
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.last_name}
                                                        />
                                                        {errors.last_name && touched.last_name ?
                                                            (<div className='f-field-errors'>{errors.last_name}</div>): null
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                            <button className='form-f-button' type="submit" disabled={isSubmitting}>
                                                Save Profile
                                            </button>
                                            {dirty ?
                                                <button className='form-cancel-button' type="cancel" disabled={isSubmitting}
                                                        onClick={handleReset}>
                                                    Reset Form
                                                </button> :
                                                <button className='form-cancel-button' type="cancel" disabled={isSubmitting}
                                                        onClick={this.editProfile}>
                                                    Cancel
                                                </button>
                                            }
                                        </Form>
                                    )}

                                </Formik>:
                                <Formik
                                    initialValues={{
                                        role: this.state.user.role.name,
                                        email: this.state.user.email,
                                        first_name: this.state.cData.first_name,
                                        last_name: this.state.cData.last_name,
                                    }}
                                    enableReinitialize={true}>

                                    {({
                                          values,
                                          errors,
                                          touched,
                                          handleChange,
                                          handleBlur,
                                          handleSubmit,
                                          isSubmitting,
                                          setFieldValue,

                                      }) => (
                                        <Form className='my-f-form' onSubmit={handleSubmit}>
                                            <h3>Authorized Reseller Portal Permissions</h3>
                                            <FieldArray
                                                name='role'
                                                render={arrayHelpers => (
                                                    <div className='toggle-radio-gr-table'>
                                                        {roleOptions.map(option => (
                                                            <div key={option.id} className='toggle-radio-gr-container'>
                                                                <input
                                                                    name='role'
                                                                    type='checkbox'
                                                                    className='toggle--radio--btn'
                                                                    value={option.id}
                                                                    checked={values.role.includes(option.id)}
                                                                />
                                                                <div className='toggle--radio-content'>
                                                                    <div className='toggle--radio--title'>{option.display}</div>
                                                                    <div className='toggle--radio--subtitle'> {option.description} </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            />
                                            <h3>Primary Contact Information</h3>
                                            <label className='form-f-label'>Email*</label>
                                            <Field
                                                component='input'
                                                className='form-f-field'
                                                type='text'
                                                name='email'
                                                value={values.email}
                                                readOnly={true}
                                            />
                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='form-f-label'>First Name*</label>
                                                    <Field
                                                        component='input'
                                                        className='form-f-field'
                                                        type='text'
                                                        name='first_name'
                                                        value={values.first_name}
                                                        readOnly={true}
                                                    />
                                                </div>
                                                <div className='flex-field-container last'>
                                                    <label className='form-f-label'>Last Name*</label>
                                                    <Field
                                                        component='input'
                                                        className='form-f-field'
                                                        type='text'
                                                        name='last_name'
                                                        value={values.last_name}
                                                        readOnly={true}
                                                    />
                                                </div>
                                            </div>

                                        </Form>
                                    )}

                                </Formik>

                            }
                        </div>
                    </div> :
                    <Loader/>
                }
            </section>
        )
    }
}

ViewAdminProfile.propTypes = propTypes;


// WEBPACK FOOTER //
// ./src/routes/AdminViewUser/ViewAdminProfile.js